
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logbook",
      function () {
        return require("private-next-pages/logbook.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/logbook"])
      });
    }
  